import React, { useContext } from "react";
import { Input } from "antd";
import Form from "antd/lib/form/Form";
import { ImplementerProfileFormContext } from "../../ImplementerProfileFormContext";

export const ExteriorNumberInput = (props: any) => {
  const implementerAccountContext = useContext(ImplementerProfileFormContext);
  const {
    form,
    isBusy,
    onFieldsChange,
    implementerProfile
  } = implementerAccountContext;
  const { getFieldDecorator } = form;

  const onChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    onFieldsChange({
      key: event.target.name,
      value: event.target.value
    });
  };

  return (
    <Form.Item label="Número exterior">
      {getFieldDecorator("exteriorNumber", {
        initialValue: implementerProfile?.exteriorNumber
      })(
        <Input
          disabled={isBusy}
          id="exteriorNumber"
          name="exteriorNumber"
          placeholder="Número exterior"
          onChange={onChange}
          size="large" />
      )}
    </Form.Item>
  );
};
